import {ActivatedRoute} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {MappedStammdaten} from '../../mapping/stammdaten/stammdaten-mapping';
import {FrontendDocument, FrontendStatusEnum} from '@nachdigal';
import {StammdatenService} from '../../service/stammdaten.service';
import {AppInjector} from '../../../app-injector';

@Component({template: ''})
export abstract class WizardPageBaseComponent<T> implements OnInit {

  public enumKeys = Object.keys;
  public data: T;
  public stammdaten: MappedStammdaten;
  public metadata: Record<string, unknown>;
  public frontendDocument: FrontendDocument;
  protected stammdatenService: StammdatenService;

  protected constructor(protected readonly activatedRoute: ActivatedRoute) {
    this.data = {} as T;
    const injector = AppInjector.getInjector();
    this.stammdatenService = injector.get(StammdatenService);
  }

  public get readonly(): boolean {
    return this.frontendDocument.status === FrontendStatusEnum.SendingConfirmed ||
      this.frontendDocument.status === FrontendStatusEnum.SendingFinalized ||
      this.frontendDocument.status === FrontendStatusEnum.Sending ||
      this.frontendDocument.status === FrontendStatusEnum.SendingSuccessful;
  }

  public ngOnInit(): void {
    this.data = this.getData();
    this.stammdaten = this.activatedRoute.snapshot.data.stammdaten;
    this.metadata = this.activatedRoute.snapshot.data.metadata;
    this.frontendDocument = this.activatedRoute.snapshot.parent.data.document;

    if (!this.metadata.touched && !this.readonly) {
      this.stammdatenService.assignStammdatenIfDeterministic(this.getStammdatenMappingRules(), this.data);
    }
  }

  protected getData(): T {
    return this.activatedRoute.snapshot.data.data;
  }

  protected abstract getStammdatenMappingRules(): Map<string, unknown | Array<unknown>>;
}
